/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const keyboardReturn = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24">
		<Path d="M16 4h2v9H7v3l-5-4 5-4v3h9V4z" />
	</SVG>
);

export default keyboardReturn;
